import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { TabViewModel } from '@core/models/tab-view.model';
import { TabBarComponent } from '../tab-bar/tab-bar.component';

@Component({
  selector: 'xemex-tab-view',
  imports: [TabBarComponent],
  templateUrl: './tab-view.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './tab-view.component.scss',
})
export class TabViewComponent {
  tabs = input<Array<TabViewModel>>([]);
  defaultTab = input(0);
  mode = input<'route' | 'index'>('route');
  tabChange = output<string>();

  onTabBarChange(route: string) {
    this.tabChange.emit(route);
  }
}
